/* eslint-disable */

//import Flickity from 'flickity/dist/flickity.pkgd';

var rotateArrayBackwards = function(arr, k) {
  let i = 0;
  while(i < k) {
    //nums.unshift(nums.pop());
    arr.push(arr.shift());
    i++;
  }
  return arr;
}

function createFlickityLightbox(listOfUrls) {
  //Lisätään lightbox bodyyn
  $('body').append('<div id="lightbox-slider"><div class="lightbox-slider">' +
  '<div class="lightbox-slider-background"></div>' + 
  '<i class="lightbox-exit fas fa-times-circle fa-3x"></i>' + 
  '<div class="flickity-lightbox">' +
  '</div>' +
  '</div></div>');

  //Tehdään lightboxin sisältö
  var i;
  for(i = 0; i < listOfUrls.length; i++){
    $('.flickity-lightbox').append(
      '<div class="flickity-lightbox-cell">' +
        '<div class="img-container">' + 
        '<img src="' + listOfUrls[i] + '" loading="lazy" />' +
        '</div>' + 
      '</div>'
    );
  }

  //Luodaan flickity slider
  var elem = document.querySelector('.flickity-lightbox');
  var flkty_lightbox = new Flickity( elem, {
    accessibility: true,
    adaptiveHeight: true,
    cellSelector: '.flickity-lightbox-cell',
    autoPlay: false,
    cellAlign: 'center',
    contain: false,
    draggable: '>1',
    dragThreshold: 3,
    freeScroll: false,
    friction: 0.2,
    groupCells: 1,
    initialIndex: 0,
    lazyLoad: true,
    percentPosition: true,
    prevNextButtons: true,
    pageDots: false,
    resize: true,
    rightToLeft: false,
    setGallerySize: true,
    watchCSS: false,
    wrapAround: true
  });

  flkty_lightbox.resize();
}

//Lightbox poistuminen
$(document).on('click', '.lightbox-exit', function() {
  $('#lightbox-slider').remove();
});

$(document).on('click', '.lightbox-slider-background', function() {
  $('#lightbox-slider').remove();
});

//Single Product Images
if($(".flickity-product").length) {
  var elem = document.querySelector('.flickity-product');
  var flkty = new Flickity( elem, {
    prevNextButtons: false,
    pageDots: false
  });

  if($('.flickity-navigation').length) {
    var elem2 = document.querySelector('.flickity-navigation');
    var flktynav = new Flickity( elem2, {
      asNavFor: '.flickity-product',
      pageDots: false
    });
  }

  $(window).load(function() {
    flkty.resize();

    if($('.flickity-navigation').length) {
      flktynav.resize();
    }
  });
}

$('#product-zoom').on('click', function() {
  var currentUrl = $('.flickity-product .flickity-slider .is-selected').data('imageurl');

  var listOfUrls = [];
  var index = 0;
  var rotateAmount = 0;
  $('.flickity-cell-product').each(function() {
    var imageUrl = $(this).data('imageurl');
    listOfUrls.push(imageUrl);
    if(currentUrl == imageUrl) {
      rotateAmount = index;
    }
    index++;
  });

  rotateArrayBackwards(listOfUrls, rotateAmount);

  createFlickityLightbox(listOfUrls);
});

/* Eläinnostot flickity */
if($('.flickity-animals-container').length) {
  $('.flickity-animals-container').each(function() {
    //var blockid = $(this).data('blockid');
    //var elem = document.querySelector('#flickity-image-gallery-' + blockid);
    var elem = document.querySelector('.flickity-animals-container');

    var flkty = new Flickity( elem, {
      on: {
        ready: function() {
          //flkty.resize();
        }
      },
      prevNextButtons: true,
      pageDots: true,
      imagesLoaded: true,
      cellAlign: 'left',
      autoPlay: 3000,
      contain: true,
      wrapAround: true,
    });

    $(window).load(function() {
      flkty.resize();
    });
  }); 
}

/* Kuvakaruselli flickity */
if($('.flickity-image-gallery').length) {
  $('.flickity-image-gallery').each(function() {
    var blockid = $(this).data('blockid');
    var elem = document.querySelector('#flickity-image-gallery-' + blockid);

    var flkty = new Flickity( elem, {
      on: {
        ready: function() {
          console.log('Flickity ready');
        }
      },
      prevNextButtons: true,
      pageDots: false,
      imagesLoaded: true,
      cellAlign: 'left',
      contain: true,
    });

    flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
      var currentUrl = $(cellElement).find('.image').data('imageurl');
      var blockid = $(cellElement).find('.image').data('blockid');

      var listOfUrls = [];
      var index = 0;
      var rotateAmount = 0;
      $('#flickity-image-gallery-' + blockid + ' .image').each(function() {
        var imageUrl = $(this).data('imageurl');
        listOfUrls.push(imageUrl);
        if(currentUrl == imageUrl) {
          rotateAmount = index;
        }
        index++;
      });

      rotateArrayBackwards(listOfUrls, rotateAmount);

      createFlickityLightbox(listOfUrls);
    });

    // flkty.on('change.flickity', function(event,index) {
    //   console.log('slide changed to ' + index);
    // });

    $(window).load(function() {
      flkty.resize();
    });
  }); 
}

// $('.flickity-image-gallery .image').on('click', function() {
//   var currentUrl = $(this).data('imageurl');
//   var blockid = $(this).data('blockid');

//   var listOfUrls = [];
//   var index = 0;
//   var rotateAmount = 0;
//   $('#flickity-image-gallery-' + blockid + ' .image').each(function() {
//     var imageUrl = $(this).data('imageurl');
//     listOfUrls.push(imageUrl);
//     if(currentUrl == imageUrl) {
//       rotateAmount = index;
//     }
//     index++;
//   });

//   rotateArrayBackwards(listOfUrls, rotateAmount);

//   createFlickityLightbox(listOfUrls);
// });

/* Majoitus flickity */
if($(".flickity-majoitus").length) {
  $('.flickity-majoitus').each(function() {

    var blockid = $(this).data('blockid');
    var elem = document.querySelector('#flickity-majoitus-' + blockid);

    // var elem = document.querySelector('.flickity-majoitus');
    var flkty = new Flickity( elem, {
      prevNextButtons: true,
      pageDots: false,
      imagesLoaded: true,
      contain: true,
      cellAlign: 'left',
    });
  
    // if($('.flickity-majoitus-navigation').length) {
    //   var elem2 = document.querySelector('#flickity-majoitus-navigation-' + blockid);
    //   var parentFlickity = '#flickity-majoitus-' + blockid;
    //   var flktynav = new Flickity( elem2, {
    //     asNavFor: parentFlickity,
    //     pageDots: true,
    //     prevNextButtons: true,
    //     //cellAlign: 'left',
    //     contain: true,
    //     //groupCells: 3
    //   });
    // }
  
    $(window).load(function() {
      flkty.resize();
  
      if($('.flickity-majoitus-navigation').length) {
        flktynav.resize();
      }
    });
  });
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/autoload/flickitys.js